import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TrainingList from './TrainingsList';
import TrainingsCalendarView from './TrainingsCalendarView';
import { Button, Space } from 'antd';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useAuth } from '../../Context/AuthContext';
const TABS = [
  { key: '1', label: 'Training List' },
  { key: '2', label: 'Calendar View' },
];

const TrainingsComp = () => {
  const { authState } = useAuth();
  const [activeTab, setActiveTab] = useState('1');
  const navigate  = useNavigate();
  const location  = useLocation();
  const calendarRef = React.useRef(null);

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get('tab');
    if (tab) setActiveTab(tab);
  }, [location]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    navigate(`/trainings?tab=${key}`);
  };

  return (
    <div style={{ background: '#f5f7fa', minHeight: '100vh' }}>

      {/* ── Tab header bar ─────────────────────────────────── */}
      <div
        style={{
          background: '#fff',
          borderRadius: '8px 8px 0 0',
          borderBottom: '1px solid #e8e8e8',
          padding: '0 20px',
          marginBottom: 20,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: 0 }}>
            {TABS.filter(tab => tab.key === '1' || [1, 2].includes(Number(authState?.id))).map((tab) => {
              const isActive = activeTab === tab.key;
              return (
                <div
                  key={tab.key}
                  onClick={() => handleTabChange(tab.key)}
                  style={{
                    padding: '14px 28px',
                    cursor: 'pointer',
                    fontSize: 14,
                    fontWeight: isActive ? 700 : 500,
                    color: isActive ? '#1b67b3' : '#595959',
                    borderBottom: isActive ? '2px solid #1b67b3' : '2px solid transparent',
                    transition: 'all 0.2s',
                    userSelect: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {tab.label}
                </div>
              );
            })}
          </div>

          {activeTab === '2' && (
            <Space style={{ paddingRight: 20 }}>
              <Button 
                icon={<FileExcelOutlined />} 
                onClick={() => calendarRef.current?.handleExportExcel()} 
                style={{ color: '#1890ff', borderColor: '#1890ff' }}
              >
                Export Excel
              </Button>
              <Button 
                type="primary" 
                icon={<FilePdfOutlined />} 
                onClick={() => calendarRef.current?.handleDownloadPDF()} 
                style={{ backgroundColor: '#1d3557', borderColor: '#1d3557' }}
              >
                Download PDF
              </Button>
            </Space>
          )}
        </div>
      </div>

      {/* ── Tab content ────────────────────────────────────── */}
      <div
        style={{
          background: '#fff',
          borderRadius: '0 0 8px 8px',
          padding: '20px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}
      >
        {activeTab === '1' && <TrainingList />}
        {activeTab === '2' && <TrainingsCalendarView ref={calendarRef} />}
      </div>

    </div>
  );
};

export default TrainingsComp;
